import React from "react";

import { Alert } from "@mui/material";

export default function NexaCutoverNotice() {
  return (
    <Alert severity="error" sx={{ position: "sticky", top: 8, zIndex: 2 }}>
      Recomendamos crear órdenes y cotizaciones en NEXA a partir de ahora. Esta
      pantalla sigue disponible, pero los datos que se registren aquí podrían no
      tomarse en cuenta.
    </Alert>
  );
}
